import { Component, computed, inject, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../../core/security/auth.service';
import { RolesEnum } from '../../../core/security/roles.enum';
import { ModulesEnum } from '../../../core/security/modules.enum';

type PortalVersionCookie = 'always' | 'never' | 'unset';

@Component({
  selector: 'app-version-switch',
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule],
  templateUrl: './version-switch.component.html',
  styleUrl: './version-switch.component.scss',
})
export class VersionSwitchComponent {
  private readonly cookieService = inject(CookieService);
  private readonly authService = inject(AuthService);

  private readonly cookieName = 'x-version-v2';

  private readonly mode = signal<PortalVersionCookie>(this.readCookie());

  /**
   * Only show the one-way switch when V2 is being forced.
   * (If legacy is forced or cookie is unset, there's nothing to do in the V2 UI.)
   */
  readonly show = computed(() => {
    const hasAccess = this.authService.hasAccess([RolesEnum.Support]);
    const hasModule = this.authService.userHasPackage([ModulesEnum.BetaFeaturesModule]);
    const hasPermission = this.authService.userHasPermission([RolesEnum.NewPortalAccess]);

    console.log('hasAccess', hasAccess);
    console.log('hasModule', hasModule);
    console.log('hasPermission', hasPermission);

    return hasAccess || (hasModule && hasPermission);
  });

  readonly buttonLabel = computed(() => 'New portal');
  readonly tooltip = computed(() => 'Switch to new portal');

  switchToNewPortal(): void {
    this.cookieService.set(this.cookieName, 'always', { path: '/' });
    this.mode.set('always');
    location.reload();
  }

  private readCookie(): PortalVersionCookie {
    const raw = this.cookieService.get(this.cookieName);
    if (!raw) {
      return 'unset';
    }
    return raw === 'never' ? 'never' : 'always';
  }
}
